angular.module('SpidApp')

.constant('StockFlowAdapterConfig', {
  name : 'StockFlow',
  fields : [
    {
    	local   : 'orderable_id',
    	distant : 'orderable_id'
    }, {
    	local   : 'agency_id',
    	distant : 'agency_id'
    }, {
    	local   : 'diff',
    	distant : 'diff'
    }, {
    	local   : 'current',
    	distant : 'current'
    }, {
    	local   : 'type',
    	distant : 'type'
    }, {
    	local   : 'updated_at',
    	distant : 'updated_at'
    }
  ]
})